import { render, staticRenderFns } from "./layoutFooter.vue?vue&type=template&id=11a37aff&scoped=true"
import script from "./layoutFooter.vue?vue&type=script&lang=js"
export * from "./layoutFooter.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/bootstrap-grid.css?vue&type=style&index=0&id=11a37aff&prod&scoped=true&lang=css&external"
import style1 from "./layoutFooter.vue?vue&type=style&index=1&id=11a37aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a37aff",
  null
  
)

export default component.exports